import React from "react";
import classNames from "classnames";
import { Form } from "semantic-ui-react";

import Radio from "./Radio";

export default function MultipleRadioControl({
  name,
  onFocus,
  onBlur,
  onChange,
  value,
  inline = false,
  grouped = !inline,
  options = [],
  required,
  withLabelsAbove = false,
  withDescription = false,
  ...rest
}) {
  if (options.length > 0 && !Array.isArray(options[0])) {
    options = options.map((v) => [v, v]);
  }

  return (
    <Form.Group inline={inline} grouped={grouped}>
      {options.map(([v, label, description]) => (
        <Form.Field key={v} className={value === v ? "checkedField" : ""}>
          {withLabelsAbove && label && <label>{label}</label>}

          <Radio
            {...rest}
            label={!withLabelsAbove && label}
            name={name}
            value={v}
            checked={value === v}
            onFocus={onFocus}
            onBlur={onBlur}
            key={v}
            onChange={onChange}
          />
          {withDescription && (
            <div key={v + "formDesc"} onClick={() => onChange(v)} className="form-description">
              {description}
            </div>
          )}
        </Form.Field>
      ))}
    </Form.Group>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/MultipleRadio.jsx